(function() {
  var DialogController,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.CopyFieldprintController = (function(superClass) {
    extend(CopyFieldprintController, superClass);

    function CopyFieldprintController(scope, transitions, modalInstance, service, fpcResultId, year, fpcResults, fields) {
      var half;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.fpcResultId = fpcResultId;
      this.year = year;
      this.fpcResults = fpcResults;
      this.fields = fields;
      CopyFieldprintController.__super__.constructor.apply(this, arguments);
      this.fields = this.fields.map((function(_this) {
        return function(field) {
          return {
            field_id: field.field_id,
            farm_name: field.farm_name,
            field_name: field.field_name,
            disabled: !!_this.fpcResults.find(function(result) {
              return result.fields_id === field.field_id && result.year === parseInt(_this.year);
            })
          };
        };
      })(this));
      this.scope.fields = this.fields;
      half = Math.round(this.fields.length / 2);
      this.scope.splitFields = [this.fields.slice(0, half), this.fields.slice(half)];
      this.scope.save = (function(_this) {
        return function() {
          var selected;
          selected = _this.fields.filter(function(field) {
            return field.selected;
          });
          return _this.service.copy(_this.fpcResultId, selected.map(function(field) {
            return field.field_id;
          })).then(function() {
            return _this.closeWithAlert({
              type: 'success',
              msg: 'Successfully copied Fieldprint'
            });
          });
        };
      })(this);
    }

    return CopyFieldprintController;

  })(DialogController);

}).call(this);
